import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ArchiveIcon, Button } from '@occc-app/design-system';

import { routeCreator } from '../../../../messaging-center.utils';
import { ARCHIVE_BUTTON_TITLE } from '../../../messaging-campaign-archive/messaging-campaign-archive.constants';
import { useMessagingCampaignArchiver } from '../../../messaging-campaign-archive/use-messaging-campaign-archiver';
import { MessagingCampaignArchiveConfirmDialog } from '../../../messaging-campaign-archive/messaging-campaign-archive-confirm-dialog.component';

type ArchiveProps = {
  campaignId: string;
};

export const Archive = ({ campaignId }: ArchiveProps) => {
  const navigate = useNavigate();

  const archiver = useMessagingCampaignArchiver({
    onCompleted: useCallback(() => {
      navigate(routeCreator.campaignsList());
    }, [navigate]),
  });

  const { archive } = archiver;

  const triggerArchive = useCallback(() => {
    archive(campaignId);
  }, [archive, campaignId]);

  return (
    <>
      <Button
        disabled={archiver.isLoading}
        color='secondary'
        variant='contained'
        startIcon={<ArchiveIcon />}
        onClick={triggerArchive}
      >
        {ARCHIVE_BUTTON_TITLE}
      </Button>

      {archiver.isConfirming ? (
        <MessagingCampaignArchiveConfirmDialog
          onClose={archiver.onCancel}
          onConfirm={archiver.onConfirm}
          loading={archiver.isLoading}
        />
      ) : null}
    </>
  );
};
